import React from 'react';
import { extensions } from '@yola/ws-sdk';
import common from '../constants/common';
import LayersSelect from '../components/layer-select';

const { SELECT_LAYER } = common;

const selectLayerControl = {
  id: SELECT_LAYER,
  trigger: <LayersSelect />,
  width: 132,
  matches(liveElement) {
    const settings = extensions.accessors.getExtensionSettings(common.slug);

    return liveElement.matches(settings.querySelector);
  },
  priority: 100,
};

export default selectLayerControl;
